module.exports = __webpack_public_path__ + "static/media/48100020-tuE0wSgs.519604a5.JPG";